module.exports = __webpack_public_path__ + "assets/a3ee451d2bd12b00e149a89fd92e396f.png";